import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

// @ts-ignore
import WorkflowCapabilityReasonHowToFix from '@/components/dialogs/CouldntDowngradeBillingPlanDialog/WorkflowCapabilityReasonHowToFix.vue';
// @ts-ignore
import { WORKFLOW_CAPABILITIES_MAP } from '@/components/dialogs/CouldntDowngradeBillingPlanDialog/capabilities-consts';

export default /*#__PURE__*/_defineComponent({
  __name: 'WorkflowCapabilityReason',
  props: {
    flow: null,
    reasons: null
  },
  setup(__props: any) {

const props = __props as {
	flow: number;
	reasons: string[];
}

const BASE_URL = process.env.VUE_APP_APP_URL;



const featureLink = computed(() => `${BASE_URL}feature-details/${props.flow}`);

return { __sfc: true,BASE_URL, props, featureLink, WorkflowCapabilityReasonHowToFix, WORKFLOW_CAPABILITIES_MAP }
}

})